<template>
  <v-container fluid>
    
    <h2 class="text-md-center text-lg-center text-sm-center earth-color">
      BOOKING PAYMENT
    </h2>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex md3>
          <side-bar></side-bar>
        </v-flex>
        <v-flex md8 ml-5>
          <h4 class="earth-color">DONATE TO CONSERVATION EFFORTS</h4>
          <v-layout row wrap>
            <v-flex lg4 md4 sm12 xs12
              ><v-container>
                <v-autocomplete
                  label="Currency"
                  v-model="on_payment_donation.donation_currency"
                  :items="allCurrencies"
                  @change="changeCurrencyDonation"
                  :return-object="true"
                  item-text="currency_name"
                  item-value="currency_public_id"
                ></v-autocomplete> </v-container
            ></v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Amount"
                  v-model="on_payment_donation.donation_amount"
                  type="number"
                ></v-text-field>
              </v-container>
            </v-flex>

            <v-flex lg4 d4 sm12 xs12>
              <v-container>
                <v-btn
                  :depressed="true"
                  color="primary"
                  @click="addOnlinePaymentDonation"
                  >Add Donation</v-btn
                >
              </v-container>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex
              lg4
              md4
              sm4
              xs4
              height="300px"
              v-if="paymentKESPrice < 70000"
            >
              <v-card max-width="300" flat>
                <img
                  src="https://marketplace.datingpro.com/image/data/payment%20systems/m-pesa-integration.png"
                  width="100%"
                  height="100%"
                  class="center-block"
                />
                <v-card-title primary-title>
                  <div>
                    <h1 class="earth-color">Pay via Mpesa</h1>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <input
                    v-model="payment_mode"
                    v-if="paymentKESPrice < 70000"
                    type="radio"
                    value="Mpesa"
                    class="form-control"
                  />
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex lg4 md4 sm4 xs4 height="300px">
              <v-card max-width="300" flat>
                <img
                  src="https://www.freeiconspng.com/uploads/credit-cards-icon-25.png"
                  width="100%"
                  height="100%"
                  alt
                />
                <v-card-title primary-title>
                  <div>
                    <h1 class="earth-color">Pay via Card</h1>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <input
                    v-model="payment_mode"
                    type="radio"
                    value="Card"
                    class="form-control"
                  />
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <br />
          <v-layout row v-if="payment_mode === 'Card'">
            <v-flex lg12 md12 xs12 sm12>
              <v-card flat>
                <v-container>
                  <form
                    id="myform"
                    name="myform"
                    method="POST"
                    action="https://portal.host.iveri.com/Lite/Authorise.aspx"
                  >
                    <!-- Mandatory form variables  -->
                    <input
                      v-if="singleBooking.booking_currency_name === 'USD'"
                      id="Lite_Merchant_Applicationid"
                      name="Lite_Merchant_Applicationid"
                      type="hidden"
                      :value="live_id"
                      readonly="true"
                    />
                    <input
                      v-if="singleBooking.booking_currency_name === 'KES'"
                      id="Lite_Merchant_Applicationid"
                      name="Lite_Merchant_Applicationid"
                      type="hidden"
                      :value="kes_live_id"
                      readonly="true"
                    />
                    <input
                      v-if="singleBooking.booking_currency_name === 'USD'"
                      id="Lite_Order_Amount"
                      name="Lite_Order_Amount"
                      type="hidden"
                      :value="bookingPaymentUSDPrice"
                      readonly="true"
                    />
                    <input
                      v-if="singleBooking.booking_currency_name === 'KES'"
                      id="Lite_Order_Amount"
                      name="Lite_Order_Amount"
                      type="hidden"
                      :value="bookingPaymentUSDPrice"
                      readonly="true"
                    />
                    <input
                      type="hidden"
                      name="Lite_Website_Successful_url"
                      :value="iveri_catcher_url + 'booking-payment'"
                    />
                    <!-- NEED TO BE CHANGED -->
                    <input
                      type="hidden"
                      name="Lite_Website_Fail_url"
                      :value="iveri_catcher_url + 'iveri-payment-failure'"
                    />
                    <!-- NEED TO BE CHANGED -->
                    <input
                      type="hidden"
                      name="Lite_Website_TryLater_url"
                      :value="iveri_catcher_url + 'iveri-payment-failure'"
                    />
                    <!-- NEED TO BE CHANGED -->
                    <input
                      type="hidden"
                      name="Lite_Website_Error_url"
                      :value="iveri_catcher_url + 'iveri-payment-failure'"
                    />
                    <!-- NEED TO BE CHANGED -->
                    <input
                      id="Lite_Currency_AlphaCode"
                      name="Lite_Currency_AlphaCode"
                      type="hidden"
                      :value="singleBooking.booking_currency_name"
                      readonly="true"
                    />
                    <input
                      id="Lite_Order_LineItems_Product_1"
                      name="Lite_Order_LineItems_Product_1"
                      type="hidden"
                      value="Booking Total"
                      readonly="true"
                    />

                    <input
                      id="Lite_Order_LineItems_Quantity_1"
                      name="Lite_Order_LineItems_Quantity_1"
                      type="hidden"
                      value="1"
                      readonly="true"
                    />
                    <input
                      id="Lite_Order_LineItems_Amount_1"
                      name="Lite_Order_LineItems_Amount_1"
                      type="hidden"
                      :value="bookingPaymentUSDPrice"
                      readonly="true"
                    />
                    <input
                      id="Lite_ConsumerOrderID_PreFix"
                      name="Lite_ConsumerOrderID_PreFix"
                      type="hidden"
                      value="DML"
                      readonly="true"
                    />
                    <input
                      id="Ecom_BillTo_Online_Email"
                      name="Ecom_BillTo_Online_Email"
                      type="hidden"
                      :value="singleBooking.booking_details.email_address"
                    />
                    <input
                      id="Ecom_Payment_Card_Protocols"
                      name="Ecom_Payment_Card_Protocols"
                      type="hidden"
                      value="iVeri"
                      readonly="true"
                    />
                    <input
                      id="BOOKINGID"
                      name="BOOKINGID"
                      type="hidden"
                      :value="singleBooking.booking_public_id"
                    />
                    <input
                      id="Ecom_TransactionComplete"
                      name="Ecom_TransactionComplete"
                      type="hidden"
                      value
                      readonly="true"
                    />
                    <!-- End-->
                    <font color="red">
                      <p class="warningtext" id="warning" name="warning">
                        &nbsp;
                      </p>
                    </font>
                    <li>
                      <v-text-field
                        id="txtEmail"
                        name="txtEmail"
                        v-model="singleBooking.booking_details.email_address"
                        :rules="requiredRules"
                        label="Email"
                        required
                        class="text-center"
                      ></v-text-field>
                    </li>
                    <li>
                      <input
                        type="text"
                        id="Amount"
                        hidden="hidden"
                        name="Amount"
                        class="text"
                        :value="bookingPaymentUSDPrice"
                      />
                      <a href="#" class="icon user" tabindex="-1"></a>
                    </li>

                    <br />
                    <div class="submit">
                      <div class="row text-center">
                        <div class="col-md-12 text-center">
                          <v-btn
                            :depressed="true"
                            type="submit"
                            id="btnsubmit"
                            class="btn primary text-center"
                            name="btnsubmit"
                            @click="checkForPaymentDonation()"
                            color="primary"
                            >Proceed to Card Payment</v-btn
                          >
                        </div>
                      </div>
                      <br />
                      <br />
                      <h3 class="text-center earth">
                        PLEASE RE-CONFIRM YOUR EMAIL ADDRESS TO PROCEED WITH
                        PAYMENT
                      </h3>
                      <div class="clear"></div>
                    </div>
                  </form>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="payment_mode === 'Mpesa'">
            <v-flex lg12 md12 xs12 sm12>
              <v-card flat>
                <div class="text-center">
                  <v-container>
                    <div class="earth text-center">
                      KINDLY NOTE THAT PAYMENTS ABOVE KES 70,000 CANNOT BE
                      PROCESSED
                    </div>
                    <br />
                    <br />
                    <div class="text-center">
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          <v-text-field
                            v-model="mpesa.phone_number"
                            :rules="requiredRules"
                            label="Payer's Safaricom number"
                            required
                            class="text-center"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg12 md6 sm12 xs12>
                          <v-container>
                            <v-btn
                              :depressed="true"
                              type="submit"
                              id="btnsubmit"
                              class="btn primary text-center"
                              name="btnsubmit"
                              color="primary"
                              block
                              @click="requestPayment()"
                              >Request Payment</v-btn
                            >
                          </v-container>
                        </v-flex>
                        <v-flex
                          lg6
                          md6
                          sm12
                          xs12
                          v-if="payment_requested === true"
                        >
                          <v-container>
                            <v-btn
                              :depressed="true"
                              color="warning"
                              block
                              @click="checkPayment()"
                              :loading="$loadingTrue"
                              >Confirm Payment</v-btn
                            >
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-container>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    {{ redirectIfPaid }}
    {{ currencyChangeBasedOnPaymentType }}
  </v-container>
</template>

<script>
import FrontNavigation from "../Repeated/FrontNavigation";
import SideBar from "../Repeated/SideBar";
import myCaptcha from "vue-captcha";
export default {
  components: {
    "my-captcha": myCaptcha,
    SideBar,
    FrontNavigation,
  },
  name: "payment-information",
  data() {
    return {
      on_payment_donation: {
        donation_currency_id: "",
        donation_currency_name: this.browserCurrency,
        donation_amount: "",
        donation_currency_buy_rate: "",
        donation_currency_sell_rate: "",
      },
      requiredRules: [(v) => !!v || "This field is required"],
      Lite_Order_LineItems_Product: "Lite_Order_LineItems_Product_",
      Lite_Order_LineItems_Quantity: "Lite_Order_LineItems_Quantity_",
      Lite_Order_LineItems_Amount: "Lite_Order_LineItems_Amount_",
      // currency: "",
      payment_requested: false,
      card_button: false,
      items: "",
      mpesa: {
        phone_number: "254",
      },
      payment_mode: "",
      iveri_url: "https://bookings.olpejetaconservancy.org/",
      // P: 'https://167.99.85.35:8001/'
      iveri_catcher_url: "https://bookings.olpejetaconservancy.org:5019/",
    };
  },
  methods: {
    checkPayment() {
      this.$store.dispatch("loading_true");
      this.$store.dispatch("get_booking", this.$route.params.booking_id);
      this.payment_mode = "Mpesa";
    },
    captchaOk() {
      this.card_button = true;
    },
    requestPayment: function () {
      this.payment_requested = true;
      let localDonation = this.$store.state.DonationStore.online_donation;
      let donation_infor = [];
      if (localDonation.length > 0) {
        let total_donation = this.totalOnlineDonations;
        donation_infor = [
          {
            new_donation_currency_id: this.browserCurrencyID,

            new_donation_currency_name: this.browserCurrency,

            new_donation_amount: total_donation,

            new_donation_currency_buy_rate: 1,
            new_donation_currency_sell_rate: 1,
          },
        ];
      }
      var data = {
        phone: this.mpesa.phone_number,
        booking_id: this.$route.params.booking_id,
        public_donations: donation_infor,
        session_id: "guest",
      };
      this.$store.dispatch("booking_mpesa_request", data);
    },
    // changeCurrency(currency) {
    //   this.currency = currency;
    // },
    itemsToSend_: function () {
      var singleBooking = this.singleBooking;
      var items = this.items;
      if (singleBooking.guest_total > 0) {
        for (let i = 0; i < singleBooking.guest_total; i++) {
          if (singleBooking.guests[i].payment_guests > 0) {
            items += items + "," + singleBooking.guests[i].payment_person;
            this.items = items;
          }
        }
      }
    },

    changeCurrencyDonation(name) {
      this.on_payment_donation.donation_currency_id = name.currency_public_id;
      this.on_payment_donation.donation_currency_name = name.currency_name;
      this.on_payment_donation.donation_currency_buy_rate =
        name.buying_selling[0].buy_amount;
      this.on_payment_donation.donation_currency_sell_rate =
        name.buying_selling[0].sell_amount;
    },
    addOnlinePaymentDonation() {
      this.totalOnlineDonations;
      let online_donation = {
        new_donation_currency_id: this.on_payment_donation.donation_currency_id,
        new_donation_currency_name:
          this.on_payment_donation.donation_currency_name,
        new_donation_amount: this.on_payment_donation.donation_amount,
        new_donation_currency_buy_rate:
          this.on_payment_donation.donation_currency_buy_rate,
        new_donation_currency_sell_rate:
          this.on_payment_donation.donation_currency_sell_rate,
      };
      this.$store.commit("ADD_ONLINE_DONATION", online_donation);
      this.paymentUSDPrice;
    },
    checkForPaymentDonation() {
      let localDonation = this.$store.state.DonationStore.online_donation;
      let donation_infor = [];
      if (localDonation.length > 0) {
        let total_donation = this.totalOnlineDonations;
        donation_infor = [
          {
            new_donation_currency_id: this.browserCurrencyID,
            new_donation_currency_name: this.browserCurrency,
            new_donation_amount: total_donation,
          },
        ];
      }
      let payment_donations = {
        public_donations: donation_infor,
        booking_id: this.singleBooking.booking_public_id,
      };
      this.$store.dispatch("post_iveri_donation", payment_donations);
    },
  },
  computed: {
    currencyChangeBasedOnPaymentType() {
      if (this.payment_mode === "Mpesa") {
        var kes = {
          created_at: null,
          currency_description: "The Kenyan Shilling.",
          currency_name: "KES",
          currency_public_id: "162fface-f5f1-41de-913b-d2bb784dda3a",
          currency_sign: "KES",
          session_id: "Admin",
          updated_at: null,
        };
        this.currencyChange(kes);
      } else {
        var singleBooking = this.singleBooking;
        var currencyChange = this.currencyChange;
        this.allCurrencies.map(function (currency) {
          if (singleBooking.currency !== undefined) {
            if (currency.currency_name === singleBooking.currency) {
              currencyChange(currency);
            }
          }
        });
      }
      return null;
    },
    redirectIfPaid: function () {
      if (this.singleBooking.booking_payment_status === "Paid") {
        window.location.replace(
          "/success/booking/" + this.$route.params.booking_id
        );
      }
      return null;
    },

    paymentKESPrice: function () {
      if (this.singleBooking.currency !== undefined) {
        this.currencyChange(this.singleBooking.currency);

        var total = 0;
        total = this.convert2(
          this.singleBooking.currency,
          "KES",
          this.singleBooking.booking_payment_balance
        ).amount;
        return total;
      }
    },
    bookingPaymentUSDPrice: function () {
      if (this.singleBooking.currency !== undefined) {
        let donationAmout = this.totalOnlineDonations;
        if (this.singleBooking.currency === "KES") {
          // this.changeCurrency("KES");

          let paying_amount = this.paymentKESPrice;
          let total_payment_kes = paying_amount + donationAmout;
          return total_payment_kes * 100;
        } else {
          // this.changeCurrency("USD");

          let booking_total_iveri = Number(
            this.convert2(
              this.singleBooking.currency,
              "USD",
              this.singleBooking.booking_payment_balance
            ).amount
          );
          let total_payment_usd =
            booking_total_iveri + Math.ceil(donationAmout);
          return total_payment_usd * 100;
        }
      }
      return this.paymentUSDPrice;
    },
    itemsToSend: function () {
      var singleBooking = this.singleBooking;
      var items = this.items;
      var instance = this;
      if (singleBooking.guest_total > 0) {
        for (let i = 0; i < singleBooking.guest_total; i++) {
          if (singleBooking.guests[i].payment_guests > 0) {
            items += items + "," + singleBooking.guests[i].payment_person;
            instance.items = items;
          }
        }
      }
      return this.items;
    },
  },
  beforeCreate() {
    this.$store.dispatch("get_payment_platforms");
    this.$store.dispatch("get_jenga_auth");
  },
  created() {
    // this.$store.dispatch("get_booking_payment", this.$route.params.booking_id);
    this.$store.dispatch("get_booking", this.$route.params.booking_id);
  },
};
</script>

<style scoped>
li {
  text-decoration: none;
  list-style: none;
}
</style>

